<template>
  <div class="card box-card">
    <div class="card-heading">
      <h4 class="card-title text-center">Incidents</h4>
    </div>
    <template v-for="incident in incidents">
      <div class="card-group" v-bind:key="incident.opened">
        <div class="card alert-card">
          <div class="card-heading alert-heading d-flex" data-toggle="collapse" v-bind:href="'#id-'+incident.opened">
            <h6 class="card-title">
              <strong>Opened: </strong>{{ incident.opened | moment('MMM Do, h:mm a') }}
              <strong>Closed: </strong>{{ incident.closed | moment('MMM Do, h:mm a') }}
            </h6>
            <h6 class="ml-auto">{{ friendlyDuration(incident.close_time) }}</h6>
          </div>
          <div v-bind:id="'id-'+incident.opened" class="card-collapse collapse">
            <ul class="list-group list-group-flush" v-for="(alert,index) in incident.alerts" v-bind:key="incident.opened + '-' + index">
              <li class="list-group-item">
                <div class="alert-name">
                  {{ alert.name }}
                </div>
                <div class="alert-details">
                  <strong>Opened: </strong>{{ alert.opened | moment('MMM Do, h:mm a') }}
                  <span>&nbsp;&nbsp;</span>
                  <strong>Closed: </strong>{{ alert.closed | moment('MMM Do, h:mm a') }}
                  <span>&nbsp;&nbsp;</span>
                  <strong>Time: </strong>{{ friendlyDuration(alert.close_time) }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Incidents',
  props: [
    'incidents'
  ],
  methods: {
    friendlyDuration: function (seconds) {
      // use dummy date to calulate the amount of hours, minutes and seconds from seconds
      // dosn't matter what 2015-01-01 is
      var format = 's [seconds]'
      if (seconds > 59) {
        format = 'm [minutes] ' + format
      }
      if (seconds > 3599) {
        format = 'H [hours] ' + format
      }
      return this.$moment('2015-01-01').startOf('day').seconds(seconds).format(format)
    }
  }
}
</script>

<style scoped src='../../assets/stylesheet/alerts.css'></style>



// WEBPACK FOOTER //
// src/components/Alerts/Incidents.vue